export function normalizeError(err: any): Error {
    if (err instanceof Error) {
        return err;
    }

    return new Error(String(err));
}
